import { z } from 'zod';
export const autocallBarrierStepSchema = z.number().nullable();
